<template>
  <date-picker v-model="inputVal" type="date"
               @input="input" value-type="timestamp"
               :clearable="false" :shortcuts="shortcuts"
               range>
    <template v-slot:input>
      <button class="btn btn-outline-dark dropdown-toggle"
              name="date"
              type="button">
        <i class="icon12-calendar-primary icon-left"></i>
        <span v-if="label">{{ label }}</span>
        <span v-if="label&&selected">: </span>
        <span>{{ selected }}</span>
      </button>
    </template>
    <template v-slot:icon-calendar>&nbsp;</template>
  </date-picker>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import _ from 'lodash';

export default {
  components: {DatePicker},
  props: {
    model: Object,
    fromAttribute: {
      type: String,
      default: 'from'
    },
    toAttribute: {
      type: String,
      default: 'to'
    },
    label: String,
    defaultShortcut: Number,
  },
  data() {
    return {
      inputVal: [null, null],
      selected: null,
      shortcuts: [
        {
          text: this.$t('today'),
          onClick: () => {
            return [
              moment().startOf('day').toDate(),
              moment().endOf('day').toDate()
            ];
          },
        },
        {
          text: this.$t('yesterday'),
          onClick: () => {
            return [
              moment().subtract('1', 'day').startOf('day').toDate(),
              moment().subtract('1', 'day').endOf('day').toDate()
            ];
          },
        },
        {
          text: this.$t('last7Days'),
          onClick: () => {
            return [
              moment().subtract('6', 'day').startOf('day').toDate(),
              moment().endOf('day').toDate()
            ];
          },
        },
        {
          text: this.$t('last30Days'),
          onClick: () => {
            return [
              moment().subtract('29', 'day').startOf('day').toDate(),
              moment().endOf('day').toDate()
            ];
          },
        },
        {
          text: this.$t('thisWeek'),
          onClick: () => {
            return [
              moment().startOf('week').toDate(),
              moment().endOf('week').toDate()
            ];
          },
        },
        {
          text: this.$t('lastWeek'),
          onClick: () => {
            return [
              moment().subtract('1', 'week').startOf('week').toDate(),
              moment().subtract('1', 'week').endOf('week').toDate()
            ];
          },
        },
        {
          text: this.$t('thisMonth'),
          onClick: () => {
            return [
              moment().startOf('month').toDate(),
              moment().endOf('month').toDate()
            ];
          },
        },
        {
          text: this.$t('lastMonth'),
          onClick: () => {
            return [
              moment().subtract('1', 'month').startOf('month').toDate(),
              moment().subtract('1', 'month').endOf('month').toDate()
            ];
          },
        },
        {
          text: this.$t('anytime'),
          onClick: () => {
            return [null, null];
          },
        },
      ],
    };
  },
  methods: {
    input() {
      if (this.inputVal[0] && this.inputVal[1]) {
        this.model[this.fromAttribute] = parseInt(moment(this.inputVal[0], 'x').startOf('day').format('x'));
        this.model[this.toAttribute] = parseInt(moment(this.inputVal[1], 'x').endOf('day').format('x'));
        let shortcut;
        try {
          shortcut = this.shortcuts.find(s => s.onClick()[0].getTime() == this.model[this.fromAttribute] && s.onClick()[1].getTime() == this.model[this.toAttribute]);
        } catch (e) {
          shortcut = null;
        }
        if (shortcut) {
          this.selected = shortcut.text;
        } else {
          this.selected = `${moment(this.inputVal[0], 'x').format('LL')} -> ${moment(this.inputVal[1], 'x').format('LL')}`;
        }
      } else {
        this.model[this.fromAttribute] = null;
        this.model[this.toAttribute] = null;
        this.selected = null;
      }
      this.$emit('change');
    },
    setSelected: _.debounce(function (text) {
      this.selected = text;
    }, 50),
  },
  mounted() {
    if (!isNaN(this.defaultShortcut)) {
      let shortcut = this.shortcuts[this.defaultShortcut];
      if (shortcut) {
        this.$bus.$on('resetTimeRangePicker', () => {
          let times = shortcut.onClick();
          const startTime = times[0] ? times[0].getTime() : null;
          const endTime = times[1] ? times[1].getTime() : null;
          this.inputVal = [startTime, endTime];
          this.selected = shortcut.text;
          this.model[this.fromAttribute] = this.inputVal[0];
          this.model[this.toAttribute] = this.inputVal[1];
          this.$emit('change');
        });
        this.$bus.$emit('resetTimeRangePicker');
      }
    }
  }
}
</script>